module.exports = __webpack_public_path__ + "static/img/a4.ce1e1238.png";